export const EDepositRuleType = {
  Flat: "flat",
  Percentage: "percentage",
  Default: "default",
} as const;
export type TDepositRuleType =
  (typeof EDepositRuleType)[keyof typeof EDepositRuleType];
